// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyTasksListViewContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-mytaskslistview" */ "./MyTasksListViewContainer")).then((page)=>{
        return {
            default: page.MyTasksListViewContainer
        };
    });
export const LazyMyTasksListViewContainer = /*#__PURE__*/ lazy(MyTasksListViewContainerLazyLoader);
